import { useSelector } from 'react-redux';
import { MinusIcon, PlusIcon } from '@rsos/assets/icons';
import { Box } from '@rsos/components/capstone/base';
import { OVERVIEW_TAB } from '@rsos/reduxDataStore/src/features/eventPane/eventPaneTabs';
import { ActionsBox, ActionButton } from './TF911.styles';

/**
 * Popover component that shows a Text-From-911 chat's participants
 * @param {Boolean} showStartChat - Flag for rendering this component
 * @param {Array} participants - List of participants for a Text-From-911 chat
 * @param {Boolean} isChatBoxVisible - Flag for expanding/collapsing the chat
 * @param {Function} onActionButtonClick - Onclick handler for toggling the
 * isTextFrom911ChatBoxVisible flag
 */
const TF911ParticipantsPopover = ({
  showStartChat,
  isChatBoxVisible,
  onActionButtonClick,
  isConversationEnded,
}) => {
  const selectedTab = useSelector(state => state.eventPane.selectedTab);

  if (showStartChat && !isConversationEnded) {
    return null;
  } else if (selectedTab === OVERVIEW_TAB) {
    return null;
  }

  return (
    <Box>
      <ActionsBox>
        <ActionButton noMargin showBorder onClick={onActionButtonClick}>
          {!isChatBoxVisible ? (
            <PlusIcon width={14} height={14} color="secondaryText" />
          ) : (
            <MinusIcon width={12} height={12} color="secondaryText" />
          )}
        </ActionButton>
      </ActionsBox>
    </Box>
  );
};

export default TF911ParticipantsPopover;
